<div class="flex flex-column w-full justify-content-center align-items-center">
    <h3 class="mb-3 mt-0" i18n>Checking login</h3>
    <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
    ></p-progressSpinner>
</div>
